export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/Genesis/theme/components/scorecard/ScorecardView/ScorecardExport.js